export default __webpack_public_path__ + "static/media/VillaBaragha.12322183.png";